import { ButtonDivIcon } from '../../../Shared/Map/markers/button-div-icon';
import { TranslationService } from '../../../../services/translation.service';
import { MarkerCluster } from 'leaflet';
import TicketOfficeClusterMarker from '../cluster-markers/ticket-office.cluster-marker';
import StopAreaClusterMarker from '../cluster-markers/stop-area.cluster-marker';
import CommuterParkingLotClusterMarker from '../cluster-markers/commuter-parking-lots.cluster-marker';

export default class StopAreaClusterDivIcon extends ButtonDivIcon {
  constructor(cluster: MarkerCluster) {
    const childMarkers = cluster.getAllChildMarkers();
    const stops = childMarkers.filter((marker) => marker instanceof StopAreaClusterMarker).length;
    const parkingSpaces = childMarkers.filter((marker) => marker instanceof CommuterParkingLotClusterMarker).length;
    const ticketOffices = childMarkers.filter((marker) => marker instanceof TicketOfficeClusterMarker).length;

    const types = [];
    if (stops > 0) types.push(`${TranslationService.get('common.stops').toLowerCase()}`);
    if (parkingSpaces > 0) types.push(`${TranslationService.get('common.parkingspaces').toLowerCase()}`);
    if (ticketOffices > 0) types.push(`${TranslationService.get('common.ticketoffices').toLowerCase()}`);

    let description = '';
    if (types.length === 1) {
      description = types[0];
    } else if (types.length === 2) {
      description = `${types[0]} ${TranslationService.get('common.and').toLowerCase()} ${types[1]}`;
    } else if (types.length > 2) {
      const lastType = types.pop();
      description = `${types.join(', ')} ${TranslationService.get('common.and').toLowerCase()} ${lastType}`;
    }

    super(
      {
        className: 'marker-cluster cluster-div-icon',
        html: `<div><span>${cluster.getChildCount()}</span></div>`,
      },
      `${TranslationService.get('stopareasearchpage.clusterwith')} ${description}`
    );
  }
}
